import { atom, selector } from "recoil";
import { ClassInfo, provinceInfo } from "type/type";
import { formattedSelectOption, formattedSelectOptionNotAll, ROLE_DIRECTOR, ROLE_TEACHER } from "utils/commonUtils";

export const isDarkAtom = atom({
    key: "Dark",
    default: false,
})
export const isSidebarAtom = atom({
    key: "Sidebar",
    default: true,
})
export const isFullScreenAtom = atom({
    key: "Fullscreen",
    default:false,
});

export const holidayState = atom<string[]>({
    key: "holidayState",
    default: [],
});

// selectSiteId
export const selectSiteIdState = atom<number>({
    key: "selectSiteIdState",
    default: 0,
});

// 사용자 역할
export const userRoleState = atom<string>({
    key: "userRoleState",
    default: "",
});

// 미사용
// 관리자/선생님 classList | 관리자: 전체 반 array, 선생님: 담당반 array
export const userClassListState = atom<ClassInfo[]>({
    key: "userClassListState",
    default: [],
});

// 미사용
// 관리자/선생님 classId
export const userClassIdState = atom<number>({
    key: "userClassIdState",
    default: 0,
});

// 미사용
// atom을 직접 변경하면 atom을 바라보고 있는 모든 컴포넌트 상태가 변경되지만, selector를 사용하면 atom을 직접 변경하지 않아 불변성 유지 가능
// seletors는 상태 기반으로 하는 파생 데이터 계산하며, 필요한 atom만 구독하기 때문에 의존성 관리 효율적
export const userClassSelectOptionState = selector<provinceInfo[]>({
    key: 'userClassSelectOptionState',
    get: ({get}) => {
        const classList = get(userClassListState);
        const userRole = get(userRoleState);

        // 클래스가 없는 경우 기본값 반환
        if (!classList || classList.length === 0) {
            return formattedSelectOption([], `${userRole === ROLE_DIRECTOR ? "전체" : "담당반 없음"}`);
        }
  
        // 옵션 데이터 형식으로 변환
        const options = classList.map((d) => ({ 
            label: d.name, 
            value: d.id 
        }));
  
        // 사용자 역할에 따른 분기 처리
        if (userRole === ROLE_DIRECTOR) {
            return formattedSelectOption(options);
        } else if (userRole === ROLE_TEACHER) {
            if (classList.length > 0) {
                return formattedSelectOptionNotAll(options);
            } else {
                return formattedSelectOption([], "담당반 없음");
            }
        }

        // 기본값 반환
        return formattedSelectOption([], `${userRole === ROLE_DIRECTOR ? "전체" : "담당반 없음"}`);
    },
});
